import React from 'react';
import { Link } from 'gatsby';
import { format } from 'date-fns';
import ExternalLink from '../ExternalLink';
import SMSFooter from './SMSFooter';
import SocialMediaFooter from './SocialMediaFooter';
import EmailForm from './EmailForm';
import AppPromo from './AppPromo';
import FooterAppPromoQRCode from '../../assets/img/DownloadAppQRCode_Footer.svg';
import styles from './FooterInformational.module.css';

export default function FooterInformational() {
  return (
    <footer className={styles.footer}>
      <div className={styles.upperContent}>
        <div className={styles.smsFooterAdvert}>
          <SMSFooter />
        </div>
        <div className={styles.advert}>
          <AppPromo QRCode={FooterAppPromoQRCode} isFooter />
        </div>
      </div>
      <div className={styles.lowerContent}>
        <div className={styles.linkRows}>
          <div className={styles.listLinks}>
            <h2 className={styles.listLinkHeader}>Our Company</h2>
            <Link className={styles.listLink} to="/get-a-fridge">
              Get a Fridge
            </Link>
            <Link className={styles.listLink} to="/press">
              Press
            </Link>
            <Link className={styles.listLink} to="/blog">
              Blog
            </Link>
            <Link className={styles.listLink} to="/careers">
              Careers
            </Link>
            <ExternalLink
              className={styles.listLink}
              href="https://farmersfridge.threadless.com/"
            >
              Merch Store
            </ExternalLink>
          </div>
          <div className={styles.listLinks}>
            <h2 className={styles.listLinkHeader}>Support</h2>

            <Link className={styles.listLink} to="/faqs">
              FAQs
            </Link>
            <Link
              className={styles.listLink}
              to="/faqs#contentful-section-1LNiTgEUA97sReDjaDb41D"
            >
              Refund Policy
            </Link>
            <ExternalLink
              className={styles.listLink}
              href="https://farmersfridge.zendesk.com/hc/en-us/requests/new"
            >
              Contact Us
            </ExternalLink>
            <a className={styles.listLink} href="tel:3122290099">
              312.229.0099
            </a>
          </div>
          <div className={styles.listLinksWithEmail}>
            <h2 className={styles.listLinkHeaderHalfSize}>
              Join our Newsletter
            </h2>
            <p className={styles.listLinkSubheader}>
              Join our mailing list to get exclusive promos, new menu updates,
              and much more!
            </p>
            <EmailForm className={styles.emailForm} />
            <h2 className={styles.listLinkHeaderHalfSize}>
              Let’s Stay in Touch
            </h2>
            <SocialMediaFooter />
          </div>
        </div>
        <hr />
        <div className={styles.disclaimer}>
          <div>
            <p className={styles.disclaimerText}>
              Our items are handcrafted in our kitchen that also makes items
              using peanuts, wheat, milk, tree nuts, shellfish, fish, egg, soy,
              and sesame.
            </p>
            <p className={styles.disclaimerText}>
              2000 calories a day is used from general nutrition advice, but
              calorie needs vary. Additional nutritional information available
              upon request.
            </p>
          </div>
          <div className={styles.terms}>
            <div className={styles.row}>
              <Link className={styles.termsLink} to="/terms-and-conditions">
                Terms & Conditions
              </Link>
              <Link className={styles.termsLink} to="/privacy">
                Privacy Policy
              </Link>
            </div>

            <p className={styles.disclaimerText}>
              © {format(new Date(), 'yyy')}, Farmer’s Fridge
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
